import { useEffect, useState } from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import ProfileModal from "../ProfileModal";
const { ApiHelper } = require("../../utils/ApiHelper");
const { COMPANIES_DATA } = require("../../lib/API_KEYS");

export default function SellerProfilesCard() {
  const [sellerData, setSellerData] = useState([]);
  const [showProfile, setShowProfile] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    const fetchSellersData = async () => {
      const res = await new ApiHelper().FetchFromServer(...COMPANIES_DATA, { type: 'Seller', pagination: false });
      setSellerData(res.data.results || null);
    }
    fetchSellersData()
  }, [])

  const handleProfileClick = (companyId) => {
    setSelectedCompanyId(companyId);
    setShowProfile(true);
  };

  const formatJoinedDate = (dateString) => {
    if (!dateString) return "Recently joined";
    
    const date = new Date(dateString);
    const options = { month: 'long', year: 'numeric' };
    return `Joined on ${date.toLocaleDateString('en-US', options)}`;
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} color="#fbbf24" size={16} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} color="#fbbf24" size={16} />);
      } else {
        stars.push(<FaRegStar key={i} color="#fbbf24" size={16} />);
      }
    }
    return stars;
  };

  return (
    <div className="card shadow-sm w-100 h-100 border rounded-4 d-flex flex-column">

      <div className="d-flex justify-content-between align-items-center p-3 ">
        <h6 className="mb-0 fw-semibold">Seller Profiles</h6>
      </div>


      <hr className="mt-0 mb-0" />


      <div className="card-body p-3 flex-grow-1 overflow-auto">
        {sellerData.slice(0, 3).map((profile, idx) => (
          <div
            key={profile._id}
            className='d-flex align-items-center py-3'
            style={{ cursor: 'pointer' }}
            onClick={() => handleProfileClick(profile._id)}
          >

            <img
              src={profile.logo || '/favicon.ico'}
              alt={profile.name}
              className="rounded-circle me-3"
              style={{ width: 48, height: 48, objectFit: "cover" }}
            />


            <div className="flex-grow-1">
              <h6 className="mb-0 fw-semibold">{profile.name}</h6>
              <small className="text-muted">{formatJoinedDate(profile.createdAt)}</small>
            </div>


            <div className="d-flex align-items-center gap-1">
              {renderStars(profile.averageRating || 0)}
              <span className="ms-1 text-muted" style={{ fontSize: '0.85rem' }}>
                {profile.feedbackCount > 0 ? `(${profile.feedbackCount})` : '(0)'}
              </span>
            </div>
          </div>
        ))}
      </div>

      <ProfileModal
        show={showProfile}
        companyId={selectedCompanyId}
        onClose={() => setShowProfile(false)}
      />
    </div>
  );
}
